import { loader } from "routes/data-routes/billing-data/coupons/check-coupons/loader";
import {
  CheckCouponsDataRoutePath,
  CheckCouponsDataRouteType
} from "routes/data-routes/billing-data/coupons/check-coupons/route.meta";


const CheckCouponsDataRouteDefinition: CheckCouponsDataRouteType = {
  route: {
    path: CheckCouponsDataRoutePath,
    loader
  }
};

export const { route: CheckCouponsDataRoute } = CheckCouponsDataRouteDefinition;
